// extracted by mini-css-extract-plugin
module.exports = {"container":"WaysToEarnBenefit__container__qH3qr"};